// extracted by mini-css-extract-plugin
module.exports = {"tx_green":"Form_tx_green__1VW_D","form_di":"Form_form_di__13h0h","errors":"Form_errors__3ijs-"};